export const claim = [
  {
    "title": "",
    "url": "domestic/negligence/2021_02_08 PARTICULARS OF CLAIM-1.jpg"
  },
  {
    "title": "",
    "url": "domestic/negligence/2021_02_08 PARTICULARS OF CLAIM-2.jpg"
  },
  {
    "title": "",
    "url": "domestic/negligence/2021_02_08 PARTICULARS OF CLAIM-3.jpg"
  },
  {
    "title": "",
    "url": "domestic/negligence/2021_02_08 PARTICULARS OF CLAIM-4.jpg"
  },
  {
    "title": "",
    "url": "domestic/negligence/2021_02_08 PARTICULARS OF CLAIM-5.jpg"
  },
  {
    "title": "",
    "url": "domestic/negligence/2021_02_08 PARTICULARS OF CLAIM-6.jpg"
  },
  {
    "title": "",
    "url": "domestic/negligence/2021_02_08 PARTICULARS OF CLAIM-7.jpg"
  },
  {
    "title": "",
    "url": "domestic/negligence/2021_02_09 N1 PROFESSIONAL NEGLIGENCE-1.jpg"
  },
  {
    "title": "",
    "url": "domestic/negligence/2021_02_09 N1 PROFESSIONAL NEGLIGENCE-2.jpg"
  }
];
